import {
  createStaffAttentionApi,
  createStaffHomeTrendsApi,
  createStaffRequestCreateApi,
  createStaffRequestsApi,
  createStaffTeamLoadApi,
} from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { HomeRuntime } from "./runtime";

/** The runtime of the real admin app: the typed client over `fetch`. The bearer token comes from the function the other areas use. */
export function createAdminHomeRuntime(): HomeRuntime {
  const config = getAdminPublicConfig();
  const options = { baseUrl: config.apiUrl.toString(), getAccessToken: currentAccessToken };
  const requests = createStaffRequestsApi(options);
  return {
    api: createStaffAttentionApi(options),
    trends: createStaffHomeTrendsApi(options),
    teamLoad: createStaffTeamLoadApi(options),
    requestCreate: createStaffRequestCreateApi(options),
    // `GET /staff/me` answers every active staff role with the display name from the staff directory. The sign-in identity has only an
    // email address or a user id, so the greeting does not use it.
    displayName: async (callOptions) => (await requests.getSelf(callOptions)).displayName,
  };
}
